export default "__VITE_ASSET__4KjBNLyH__"